import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import { Link } from "react-scroll";
import { ReactTyped } from "react-typed";

const Home = () => {
  return (
    <div name="home" className="w-full sm:h-[100vh] h-[110vh] bg-[#0a192f]">
      {/* Container */}
      <div className="max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full">
        <p className="text-cyan-600 font-semibold sm:px-2 py-2 mt-2">
          Hello there! I am{" "}
        </p>
        <h1 className="text-4xl sm:text-7xl font-bold text-[#ccd6f6]">
          Beki Diribsa
        </h1>
        <h2 className="text-4xl sm:text-7xl py-2 font-bold text-[#8892b0]">
          I'm{" "}
          <ReactTyped
            strings={[
              "a Full Stack Developer.",
              "a Computer Engineer.",
              "an App Developer.",
            ]}
            typeSpeed={100}
            backSpeed={75}
            loop
          />
        </h2>
        <p className="text-[#8892b0] py-4 pb-9 max-w-[700px]">
          Based in Addis Ababa, Ethiopia, I am a computer engineer specializing
          in building elegant and responsive web apps using JavaScript and
          ReactJS.
        </p>
        <div className="py-1">
          <Link
            className="hover:bg-[#263e63]"
            to="work"
            smooth={true}
            duration={500}
          >
            <button className="rounded-lg text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-cyan-600 hover:border-cyan-700 duration-500">
              Take a look at some of my projects
              <span className="group-hover:rotate-90 duration-500">
                <HiArrowNarrowRight className="ml-3 text-3xl" />
              </span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
